import Styles from './Input.scss';

import Template from './Input.hbs';
import Wysiwyg from 'views/components/wysiwyg/Wysiwyg';
import Button from 'views/components/button/Button.svelte'
import TreeView from 'views/components/treeView/TreeView'
import AnnotationModel from 'models/AnnotationModel'
import InlineCrumblepath from 'views/components/inlineCrumblepath/InlineCrumblepath'

/*    ### AnnotationInputView     ###
 #
 #    This view will handle the input for the annotations.
 #    It makes it posibile to select a path and creates an
 #    WYSWYG editor for the text itself.
 #    With the selected ID's it creates a path.
 #
 */

export default class AnnotationInput extends BaseView {

    initialize({
        groupModel,
        annotationSavedCallback,
    }) {

        if (!this.model) {
            this.model = new AnnotationModel({group_id: groupModel.id})
        }

        this.setElement(Template({ Styles }));

        this.inputField = this.addChildView(
            new Wysiwyg({
                content: this.model.get('note_content') ?
                    this.model.get('note_content') :
                    sessionStorage.getItem(`annotation-draft:${Backbone.Model.user.id}`) || '',
                buttonsPreset: 'annotations',
                autoFocus: true,
            }),
            '.js-annotation-input-container'
        );
        // Listen for change events sent from the WYSIWYG editor
        this.inputField.on('change', () => {
            sessionStorage.setItem(`annotation-draft:${Backbone.Model.user.id}`, this.inputField.getContent())
        });

        this.addSvelteChildView(
            '.js-select-path',
            Button,
            {
                label: window.i18n.gettext('Place at…'),
                theme: 'secondary',
                icon: 'bookmark',
                callback: () => {

                    // Reset selected items
                    Backbone.Collection.chapters.invoke('unset', 'isChecked')
                    Backbone.Collection.sections.invoke('unset', 'isChecked')
                    Backbone.Collection.activities.invoke('unset', 'isChecked')

                    // Set current item selected in content
                    const currentPathModel = this.model.path
                    if (currentPathModel.constructor.type !== 'group') {
                        currentPathModel.set({isChecked: true})
                    }

                    // Create tree view for selecting location of annotation.
                    Backbone.View.Components.modal.open(TreeView, {
                        title: window.i18n.gettext('Save annotation with'),
                        rootCollection: this.model.getGroupModel().getChildren(),
                        isSelectable: true,
                        isSingleSelect: true,
                        expandParentsOfSelectedItems: true,
                        contentFilter: (model) => {
                            return model.constructor.type !== 'taskGroup'
                        },
                        singleSelectCallback: ({model}) => {
                            this.model.path = model
                        },
                        buttons: {
                            [window.i18n.gettext('Select')]: {
                                callback: () => {
                                    Backbone.View.Components.modal.close()
                                },
                            },
                        },
                    })
                }
            }
        )

        this.listenTo(this.model, 'change', this.showCurrentPath.bind(this))
        this.showCurrentPath()

        this.addSvelteChildView(
            '.js-save-annotation-button',
            Button,
            {
                label: window.i18n.gettext('Save annotation'),
                callback: () => {
                    if (Backbone.Model.user.get('is_demo')) {
                        Backbone.View.layout.openStatus(
                            window.i18n.gettext('Demo accounts are not allowed to save annotations'),
                            'warning'
                        )
                        return
                    }

                    this.model.set({note_content: this.inputField.getContent()})
                    this.model.saveToGroup(annotationSavedCallback)
                },
            }
        );
    }

    showCurrentPath() {
        this.destroyChildViewsOfType(InlineCrumblepath)

        this.addChildView(new InlineCrumblepath({
            pageType: 'annotate',
            isLink: false,
            model: this.model.path,
            autoScale: true,
        }), '.js-select-path')
    }

}
